export default class ResourcesLobby {
  constructor() {
    /**
     *
     * @type {{topicSelector: string, loadMore: string, clearAll: string, searchInput: string}}
     */
    this.DOM = {
      topicSelector: '.section-resources-lobby__topics .facetwp-radio',
      loadMore: '.js-load-more-resources',
      clearAll: '.js-clear-all-resources',
      searchInput: '.facetwp-search',
    };

    this.classNames = {
      visible: 'facetwp-radio--visible',
    };

    this.topicSelectors = [];
    this.clearAllButtons = [];
    this.tagsOnClick = 7;
    this.tagsDisplayed = 7;
    this.initialTags = 7;
    this.totalTags = 0;
    this.loadMore = document.querySelector(this.DOM.loadMore);
    this.loadMoreClickActive = false;
  }

  bootstrap() {
    this.init();
  }

  init() {
    this.watchFacetwpLoaded();
    this.watchResetClick();

    $('.section-resources-lobby__filter-group .filter-items__title').on('click', function() {
      /* Disable the collapse on desktop */
      if (window.innerWidth >= 768) {
        return true;
      }
      const group = $(this).parents('.section-resources-lobby__filter-group');
      if (!group.length) {
        return;
      }
      if (!group.hasClass('section-resources-lobby__filter-group--active')) {
        const closedHeight = group.height();
        group.css('height', 'auto');
        const openHeight = group.height();

        group.height(closedHeight).animate({
          height: openHeight,
        }, 350);

        group.addClass('section-resources-lobby__filter-group--active');
      } else {
        group.animate({
          height: 60,
        }, 350);

        group.removeClass('section-resources-lobby__filter-group--active');
      }
    });
  }

  watchFacetwpLoaded() {
    document.addEventListener('facetwp-loaded', () => {
      this.topicSelectors = document.querySelectorAll(this.DOM.topicSelector);
      this.totalTags = this.topicSelectors.length;

      this.displayLoadMore();
      this.watchFacetwpRadios();
      this.watchLoadMoreClick();
      this.watchResetClick();
    });
  }

  displayLoadMore() {
    if (this.loadMore) {
      if (this.tagsDisplayed >= this.totalTags) {
        this.loadMore.classList.add('d-none');
      } else {
        this.loadMore.classList.remove('d-none');
      }
    }
  }

  watchFacetwpRadios() {
    this.topicSelectors.forEach((facetwpRadio, index) => {
      if (index >= this.tagsDisplayed) {
        facetwpRadio.classList.remove(this.classNames.visible);
      } else {
        facetwpRadio.classList.add(this.classNames.visible);
      }
    });
  }

  watchLoadMoreClick() {
    if (this.loadMore && !this.loadMore.dataset.listenerAttached) {
      this.loadMore.dataset.listenerAttached = 'true';

      this.loadMore.addEventListener('click', event => {
        event.preventDefault();

        if (this.loadMoreClickActive) {
          return;
        }
        this.loadMoreClickActive = true;

        this.tagsDisplayed = this.tagsDisplayed + this.tagsOnClick;
        this.watchFacetwpRadios();
        this.displayLoadMore();

        setTimeout(() => {
          this.loadMoreClickActive = false;
        }, 500);
      });
    }
  }

  watchResetClick() {
    this.clearAllButtons = document.querySelectorAll(this.DOM.clearAll);

    this.clearAllButtons.forEach(clearAll => {
      if (clearAll.dataset.listenerAttached) {
        return;
      }

      clearAll.dataset.listenerAttached = 'true';

      clearAll.addEventListener('click', event => {
        event.preventDefault();

        this.tagsDisplayed = this.initialTags;
        this.watchFacetwpRadios();
        this.displayLoadMore();

        if (window.FWP && typeof window.FWP.reset === 'function') {
          window.FWP.reset();
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/resourcesLobby.js